import { SearchFilterResultTypeBlueprint } from '@backstage/plugin-search-react/alpha';
import Handyman from '@mui/icons-material/Handyman';

/**
 * The search page itself, its filters and the result list items for the
 * software catalog, TechDocs and tools all come from the plugins now — the
 * hand-written `SearchPage.tsx` is gone.
 *
 * `@backstage-community/plugin-explore` contributes the tools *result item* but
 * not the "Result Type" filter entry for it, so that one is added here.
 */
export const toolsSearchResultType = SearchFilterResultTypeBlueprint.make({
  name: 'tools',
  params: {
    value: 'tools',
    name: 'Tools',
    icon: <Handyman />,
  },
});
